import { ConversationMetadata } from 'types/ai.types';
import { Invoice, InvoiceItem } from 'types/invoice.types';
import { divideBy1000 } from 'utils/math';
import { useSetAiMetadata } from '.';

const getItemAmount = (item: any) =>
  divideBy1000(item.unitAmountExclVAT || item.unitAmountInclVAT);

const getTotalAmount = (items?: InvoiceItem[]) =>
  items?.reduce(
    (acc, i) => acc + getItemAmount(i) * divideBy1000(i.quantity),
    0,
  );

export const mapRevenueMetadata = (
  revenue: Partial<Invoice>,
): ConversationMetadata => ({
  documentId: revenue?._id,
  documentType: 'revenue',
  data: {
    amount: getTotalAmount(revenue.items),
    filename: revenue?.filePath?.split('/').pop(),
    currency: revenue?.currency,
    date: revenue?.invoiceDate,
    paymentDate: revenue?.paymentDate,
    status: revenue?.status,
    client: {
      name: revenue?.client?.name,
      location: revenue?.client?.location,
      type: revenue?.client?.type,
    },
    items: revenue?.items?.map((i) => ({
      name: i.name,
      category: i.category?.id,
      quantity: divideBy1000(i.quantity),
      unitAmount: getItemAmount(i),
      VATRate: divideBy1000(i.VATRate),
      doesUnitPriceIncludeVAT: i.doesUnitPriceIncludeVAT,
    })),
  },
});

export const useRevenueAiMetadata = (revenue?: Partial<Invoice>): void =>
  useSetAiMetadata(revenue, 'revenue', mapRevenueMetadata);
